import type { FigmaIconProps } from './types';

export const IconFigmaBrandMark = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={(size * 15) / 16}
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33789 5.07227H7.74414L7.9375 4.7793L9.43945 6.58984L9.28418 6.79004L15 14.3174H11.5137L7.66309 8.67188H7.25684L3.40625 14.3174H0L5.63574 6.79004L0.40625 0H3.81152L7.33789 5.07227ZM9.81738 6.10645L8.28418 4.25684L11.1084 0H14.5947L9.81738 6.10645Z"
      fill={color}
    />
  </svg>
);
